import { Injectable } from '@angular/core';
import { Selector, State, StateContext, Action } from '@ngxs/store';
import { PayrollValidation } from 'app/models/dto/payroll-validation.model';
import { PayrollValidationService } from 'app/services/payroll-validation/payroll-validation.service';
import { tap } from 'rxjs/operators';
import { GetPayrollValidation, CreatePayrollValidation, ClearPayrollValidation } from './payroll-validation.actions';

export class PayrollValidationModel {
  payrollValidation: PayrollValidation | null;
  loading: boolean;

}

@State<PayrollValidationModel>({
	name: 'payrollValidation',
	defaults: {
        payrollValidation: null,
        loading: false
	}
})

@Injectable()

export class PayrollValidationState {

  @Selector()
	static payrollValidation(state: PayrollValidationModel) {
    return state.payrollValidation;
  }

  @Selector()
	static loading(state: PayrollValidationModel) {
    return state.loading;
  }

  constructor(
    private payrollValidationService: PayrollValidationService
  ) {}

@Action(GetPayrollValidation)
getBorrower({ patchState }: StateContext<PayrollValidationModel>, { borrowerId }: GetPayrollValidation) {
    patchState({ loading: true});
    return this.payrollValidationService.get(borrowerId).pipe(tap(payrollValidation => {
        patchState({ payrollValidation, loading: false });
    }));
}

@Action(ClearPayrollValidation)
clearBorrowerValues({ patchState }: StateContext<PayrollValidationModel>, { borrowerId }: ClearPayrollValidation) {
    patchState({ loading: true});
    patchState({ payrollValidation: null, loading: false });
}

@Action(CreatePayrollValidation)
    createPayrollValidation({ patchState }: StateContext<PayrollValidationModel>, { pppValidationDocuments }: CreatePayrollValidation) {
        patchState({ loading: true});
        return this.payrollValidationService.create(pppValidationDocuments).pipe(tap(payrollValidation => {
            patchState({ payrollValidation, loading: false });
        }));
    }
}
